import React from 'react'

const ContactUs = () => {
  return (
    <h1>Contact us Page</h1>
  )
}

export default ContactUs